
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';

@Injectable()
export class TestimonialsService {

  private getTestimonialsUrl = '/testimonials.json';
  private getMerchantSliderUrl = '/merchants_for_slider.json';
  private getXpeMerchantsRedirectionTimeoutUrl = '/xpe_merchants_redirection_timeout.json';

  constructor(private backendService: BackendService) { }

  getTestimonials(): any {
    return this.backendService.getData(this.getTestimonialsUrl, null, false, true, true);
  }

  getMerchantsForSlider(): any {
    return this.backendService.getData(this.getMerchantSliderUrl, null, false, true, true);
  }

  getXpeMerchantsRedirectionTimeout(): any {
    return this.backendService.getData(this.getXpeMerchantsRedirectionTimeoutUrl, null, false, true, true);
  }

}
